import { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LEGACY_RESEARCH_REDIRECTS = {
  "/overview-projects/capacity-performance/report": {
    377: {
      title:
        "The-Judicial-Transparency-Index:-Assessing-disclosure-of-information-by-the-Supreme-Court-and-the-High-Courts",
      destination:
        "/overview-projects/capacity-performance/report?id=386&title=The-Judicial-Transparency-Index:-Assessing-disclosure-of-information-by-the-Supreme-Court-and-the-High-Courts",
    },
  },
};

const LEGACY_PATH_REDIRECTS = {
  "/jaldi-portal/portal-building-better-court":
    "/overview-projects/court-infrastructure/report?id=231&title=Building-Better-Courts:-Surveying-the-Infrastructure-of-India%E2%80%99s-District-Courts",
};

const ScrollToTop = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isCourtDesignHandbook = location.pathname
    .split("/")
    .includes("courtDesignHandbook");

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    const replacementPath = LEGACY_PATH_REDIRECTS[location.pathname];
    if (replacementPath) {
      navigate(replacementPath, { replace: true });
      return;
    }

    const legacyIds = LEGACY_RESEARCH_REDIRECTS[location.pathname];
    if (!legacyIds) {
      return;
    }

    const searchParams = new URLSearchParams(location.search);
    const legacyRedirect = legacyIds[searchParams.get("id")];
    if (
      !legacyRedirect ||
      searchParams.get("title") !== legacyRedirect.title
    ) {
      return;
    }

    navigate(`${legacyRedirect.destination}${location.hash}`, {
      replace: true,
    });
  }, [location.hash, location.pathname, location.search, navigate]);

  useLayoutEffect(() => {
    if (isCourtDesignHandbook && !location.state?.intro) {
      window.scrollTo({
        top: 650,
        left: 0,
        behavior: "smooth",
      });
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [
    isCourtDesignHandbook,
    location.key,
    location.pathname,
    location.state?.intro,
  ]);

  return null;
};

export default ScrollToTop;
